var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup274(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.56,
    height: 20,
    viewBox: "0 0 25.56 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(504.51 -154.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    "data-name": "Path 3491",
    d: "M-419.07,339.72a1.224,1.224,0,0,1-.036-.21c.009-1.008-.012-2.018.041-3.024a5.026,5.026,0,0,1,3.613-4.381.637.637,0,0,1,.418.062,5.647,5.647,0,0,0,5.577,0,.682.682,0,0,1,.451-.053,5,5,0,0,1,3.577,4.406c.05.994.03,1.993.039,2.989a1.286,1.286,0,0,1-.035.213Z",
    transform: "translate(-79.463 -165.473)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3492",
    "data-name": "Path 3492",
    d: "M-378.328,205.689a4.317,4.317,0,0,1-4.335-4.315,4.316,4.316,0,0,1,4.274-4.338,4.311,4.311,0,0,1,4.37,4.313A4.314,4.314,0,0,1-378.328,205.689Z",
    transform: "translate(-113.371 -39.813)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    d: "M-460.686,156.773a5.953,5.953,0,0,0-3.342,6.688,4.317,4.317,0,0,1-4.415-3.119A4.344,4.344,0,0,1-466,155.2,4.3,4.3,0,0,1-460.686,156.773Z",
    transform: "translate(-33.407 -0.56)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M-283.179,162.905a5.974,5.974,0,0,0-3.322-6.712,4.236,4.236,0,0,1,5.071-1.673,4.388,4.388,0,0,1,2.653,5.192A4.257,4.257,0,0,1-283.179,162.905Z",
    transform: "translate(-202.844)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M-249.21,296.513h-4.372a6.748,6.748,0,0,0-3.982-5.826c.224-.326.43-.643.658-.945a.341.341,0,0,1,.264-.1,5.814,5.814,0,0,0,3.5-.749.525.525,0,0,1,.358-.009,4.97,4.97,0,0,1,3.556,4.193C-249.137,294.2-249.21,295.341-249.21,296.513Z",
    transform: "translate(-229.768 -125.247)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M-500.071,296.675h-4.437c0-.535,0-1.053,0-1.57a8.257,8.257,0,0,1,.259-2.749,5.048,5.048,0,0,1,3.334-3.273.626.626,0,0,1,.448.03,5.622,5.622,0,0,0,3.3.711.461.461,0,0,1,.527.263,7.651,7.651,0,0,0,.555.779A6.651,6.651,0,0,0-500.071,296.675Z",
    transform: "translate(0 -125.431)",
    fill: "#febaba"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup274);
export default __webpack_public_path__ + "static/media/Group 274.7a750915493267dddca9ae3203fc5a18.svg";
export { ForwardRef as ReactComponent };